const NotFoundPage = () =>  {
    return (
        <div>
            Error 404 - Pagina no encontrada
        </div>
    );
}

export default NotFoundPage;